import axios from "axios";

const BASE_URL = "https://api.macodi.co.kr";

const publicInstance = axios.create({ baseURL: BASE_URL });
const authInstance = axios.create({ baseURL: BASE_URL });

export { publicInstance, authInstance };
